import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { GroupItem } from '../types/WorkspaceOverviewTypes';

interface GroupContentProps {
  items?: GroupItem[];
}

export const GroupContent = ({ items = [] }: GroupContentProps) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="space-y-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full justify-between"
      >
        <span className="text-xs font-medium">
          {items.length} {items.length !== 1 ? t('knowledge.overview.group_items') : t('knowledge.overview.group_item')}
        </span>
        {isExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </Button>

      {isExpanded && (
        <div className="space-y-4 mt-2">
          {items.map((item: GroupItem, index: number) => (
            <div key={`${item.name}-${index}`} className="border rounded-lg p-4 space-y-2">
              <h4 className="font-semibold text-sm">{item.name}</h4>
              <p className="text-sm text-muted-foreground">{item.description}</p>
              {Array.isArray(item.goals) && item.goals.length > 0 && (
                <div>
                  <strong className="text-xs">{t('knowledge.overview.persona_goals')}</strong>
                  <ul className="list-disc list-inside space-y-1 mt-1">
                    {item.goals.map((goal: string, i: number) => (
                      <li key={`${item.name}-goal-${i}`} className="text-sm">{goal}</li>
                    ))}
                  </ul>
                </div>
              )}
              {Array.isArray(item.pain_points) && item.pain_points.length > 0 && (
                <div>
                  <strong className="text-xs">{t('knowledge.overview.persona_pain_points')}</strong>
                  <ul className="list-disc list-inside space-y-1 mt-1">
                    {item.pain_points.map((pain: string, i: number) => (
                      <li key={`${item.name}-pain-${i}`} className="text-sm">{pain}</li>
                    ))}
                  </ul>
                </div>
              )}
              {Array.isArray(item.characteristics) && item.characteristics.length > 0 && (
                <div>
                  <strong className="text-xs">{t('knowledge.overview.persona_characteristics')}</strong>
                  <ul className="list-disc list-inside space-y-1 mt-1">
                    {item.characteristics.map((char: string, i: number) => (
                      <li key={`${item.name}-char-${i}`} className="text-sm">{char}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
